import { ComponentProps, ReactNode } from 'react';
import logo from '@/assets/phenom-logo.svg';

import styles from './SplashScreen.module.css';

interface SplashScreenProps extends ComponentProps<'div'> {
  logoHeader?: boolean;
  children: ReactNode;
}

const SplashScreen = ({ logoHeader = true, children }: SplashScreenProps) => {
  return (
    <div className={`flex h-dvh min-w-fit flex-col items-center justify-center ${styles.splashScreen}`}>
      {logoHeader && (
        <div className="mt-5 min-w-52 max-w-72 md:mt-12">
          <img src={logo} alt="Phenom Poker Logo" />
        </div>
      )}
      {children}
    </div>
  );
};

export default SplashScreen;
